import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface Duration {
  from: number;
  to: number;
}

// 自定义过滤器条件项
export interface FilterCondition {
  type: string;      // 筛选条件类型, 例如: "tag", "todo", "link" 等
  value?: string;    // 具体值, 比如标签名
  operator?: string; // 逻辑操作符: AND, OR, NOT
}

// 自定义过滤器
export interface CustomFilter {
  id: string;        // 唯一标识
  name: string;      // 过滤器名称
  conditions: FilterCondition[]; // 条件列表
  createdAt: number; // 创建时间戳
}

interface State {
  tag?: string;
  duration?: Duration;
  text?: string;
  visibility?: Visibility;
  full_tag?: boolean;
  only_orphan?: boolean;
  only_todo?: boolean;
  only_unfinish?: boolean;
  only_resource?: boolean;
  only_no_resource?: boolean;
  only_ref?: boolean;
  only_refed?: boolean;
  only_tag?: boolean;
  only_no_tag?: boolean;
  only_link?: boolean;
  only_public?: boolean;
  only_private?: boolean;
  only_untreated?: boolean;
  only_in_progress?: boolean;
  only_archived?: boolean;
  customFilters?: CustomFilter[]; // 添加自定义过滤器列表
  activeCustomFilter?: string;    // 当前激活的自定义过滤器ID
}

export type Filter = State;

const filterSlice = createSlice({
  name: "filter",
  initialState: {
    customFilters: [],
  } as State,
  reducers: {
    setFilter: (state, action: PayloadAction<Partial<State>>) => {
      if (JSON.stringify(action.payload) === state) {
        return state;
      }

      return {
        ...state,
        ...action.payload,
      };
    },
    addCustomFilter: (state, action: PayloadAction<CustomFilter>) => {
      if (!state.customFilters) {
        state.customFilters = [];
      }
      state.customFilters.push(action.payload);
    },
    updateCustomFilter: (state, action: PayloadAction<CustomFilter>) => {
      if (!state.customFilters) return state;
      
      const index = state.customFilters.findIndex(f => f.id === action.payload.id);
      if (index !== -1) {
        state.customFilters[index] = action.payload;
      }
    },
    removeCustomFilter: (state, action: PayloadAction<string>) => {
      if (!state.customFilters) return state;
      
      state.customFilters = state.customFilters.filter(f => f.id !== action.payload);
      if (state.activeCustomFilter === action.payload) {
        state.activeCustomFilter = undefined;
      }
    },
    setActiveCustomFilter: (state, action: PayloadAction<string | undefined>) => {
      state.activeCustomFilter = action.payload;
    },
  },
});

export const { 
  setFilter, 
  addCustomFilter, 
  updateCustomFilter, 
  removeCustomFilter, 
  setActiveCustomFilter 
} = filterSlice.actions;

export default filterSlice.reducer;
